import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from './utils';

export interface CardProps extends ComponentPropsWithoutRef<'div'> {
  header?: ReactNode;
  footer?: ReactNode;
  /** Remove inner padding from the body (useful for tables/images). */
  flush?: boolean;
}

export function Card({ header, footer, flush = false, className, children, ...props }: CardProps) {
  return (
    <div
      className={cn('overflow-hidden rounded-lg border border-zinc-200 bg-white shadow-sm', className)}
      {...props}
    >
      {header !== undefined && header !== null ? (
        <div className="border-b border-zinc-200 px-5 py-4">{header}</div>
      ) : null}
      <div className={cn(flush ? '' : 'p-5')}>{children}</div>
      {footer !== undefined && footer !== null ? (
        <div className="border-t border-zinc-200 px-5 py-4">{footer}</div>
      ) : null}
    </div>
  );
}

export function CardHeader({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('border-b border-zinc-200 px-5 py-4', className)} {...props} />;
}

export function CardTitle({ className, ...props }: ComponentPropsWithoutRef<'h3'>) {
  return <h3 className={cn('text-base font-semibold text-zinc-900', className)} {...props} />;
}

export function CardDescription({ className, ...props }: ComponentPropsWithoutRef<'p'>) {
  return <p className={cn('mt-1 text-sm text-zinc-500', className)} {...props} />;
}

export function CardContent({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('p-5', className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('border-t border-zinc-200 px-5 py-4', className)} {...props} />;
}
